module.exports = __webpack_public_path__ + "img/hi-to-followers.e5fef9c3.png";